module.exports = function getResource(label) {
    let resources = {
        inputLabel: 'Numéro de téléphone cellulaire'
    };

    return resources[label];
};
